import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { cmsApi, oneAssetApi } from '../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  constructor(private http: HttpClient) {}

  getFund(search) {
    let URL = cmsApi + '/get_fundBySearch';
    let body = { search: search };
    return this.http.post(URL, body);
  }

  getNews(search) {
    let URL = cmsApi + '/get_newsListBySearch';
    let body = { 	IsActive : 1, search: search };
    return this.http.post(URL, body);
  }

  getAnnounce(search) {
    let URL = cmsApi + '/get_announceListByKeyword';
    let body = { 	IsActive : 1, search: search };
    return this.http.post(URL, body);
  }

  getEarthUpdate(search) {
    let URL = cmsApi + '/get_earthupdateListByKeyword';
    let body = { IsActive : 1, search: search };
    return this.http.post(URL, body);
  }

  getFundRecom(search) {
    let URL = cmsApi + '/get_fundRecomList_active_2';
    let body = { IsActive : 1, search: search };
    return this.http.post(URL, body);
  }

  getPromotion(search) {
    let URL = cmsApi + '/get_promotionListByKeyword';
    let body = { IsActive : 1, search: search };
    return this.http.post(URL, body);
  }

  getBenefit(search) {
    let URL = cmsApi + '/get_benefitList_active_2';
    let body = { IsActive : 1, search: search };
    // console.log(search)
    return this.http.post(URL, body);
  }

}
